module.exports = __webpack_public_path__ + "img/DK54787316.97f8ccbd.png";